export const columns=[
  {
    title: "仓库",
    width: 150,
    key: "repertotyName",
  },
  {
    title: "入库单号",
    width: 150,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "入库批次",
    width: 150,
    dataIndex: "batchBizNo",
    key: "batchBizNo",
  },
  {
    title: "入库时间",
    width: 150,
    dataIndex: "lastModifiedTime",
    key: "lastModifiedTime",
  },
  {
    title: "入库单价(￥)",
    width: 150,
    dataIndex: "cost",
    key: "cost",
  },
  {
    title: "剩余库存良品",
    width: 150,
    dataIndex: "remainPerfectCount",
    key: "remainPerfectCount",
  },
  {
    title: "剩余库存次品",
    width: 150,
    dataIndex: "remainDefectiveCount",
    key: "remainDefectiveCount",
  },
  {
    title: "入库良品",
    width: 150,
    dataIndex: "putPerfectCount",
    key: "putPerfectCount",
  },
  {
    title: "入库次品",
    width: 150,
    dataIndex: "putDefectiveCount",
    key: "putDefectiveCount",
  },
  {
    title: "已出库良品",
    width: 150,
    dataIndex: "outedPerfectCount",
    key: "outedPerfectCount",
  },
  {
    title: "已出库次品",
    width: 150,
    dataIndex: "outedDefectiveCount",
    key: "outedDefectiveCount",
  },
];